/**
 * The PostHog project this site reports to. Its own module so the edge proxy
 * (`lib/edge-exposure.ts`) can read it without importing `@/lib/posthog`,
 * which pulls posthog-js into the bundle.
 */
export const POSTHOG_KEY = "phc_vO5cUVN2NR0yjaisUsANGlFmv9Gur0iUa06aH7KufiN"
// Direct host for server-to-server calls (posthog-server.ts, edge-exposure.ts).
// Browser calls go through the /ingest reverse proxy — see next.config.ts rewrites.
export const POSTHOG_HOST = "https://eu.i.posthog.com"
